module.exports = __webpack_public_path__ + "static/img/mens_program_2.b6f5a98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blocks/mens_program_2.svg
// module id = y6np
// module chunks = 0